/**
 * Base of the MagicAlbumPanel steps. data = { model, options, placing, placed }.
 *
 * whenPhotosReady() calls back once every photo is there : the magic creation opens the panel as soon
 * as the photos are picked, while they are still being extracted on this device (PhotoExtractor,
 * MediasUploader) or sent from a phone (SmsService).
 */
fx.ns("shared.screens.magic", class BaseStep extends fx.Component {

    constructor()
    {
        super();

        this._readyCallback = null;
    }

    get model()
    {
        return this.data.model;
    }

    get options()
    {
        return this.data.options;
    }

    get photosPending()
    {
        let photos = this.model.photos;
        let uploader = fx.service("MediasUploader");
        let sms = fx.service("SmsService");

        return !!((photos && photos.extracting) || (uploader && uploader.extracting) || (sms && sms.pending));
    }

    whenPhotosReady(callback)
    {
        if (!this.photosPending)
        {
            callback();
            return;
        }

        this._readyCallback = callback;
        this.repeat(this._checkPhotos, 500);
    }

    _checkPhotos()
    {
        if (this.photosPending)
            return;

        this.repeat(this._checkPhotos, null);

        let callback = this._readyCallback;
        this._readyCallback = null;

        if (callback)
            callback();
    }

    destroy()
    {
        this._readyCallback = null;
        this.repeat(this._checkPhotos, null);

        super.destroy();
    }
});
